import $ from "jquery";
import { createPopper } from '@popperjs/core';

$('.modal-video').on('hide.bs.modal', function(e) {
    var $iframe = $(this).find("iframe");
    var iframeSrc = $iframe.attr("src");
    $iframe.attr("src", '');
    $iframe.attr("src", iframeSrc);
});